// extracted by mini-css-extract-plugin
module.exports = {"root":"IconButton_root__na416","edgeEnd":"IconButton_edgeEnd__PxMwm","edgestart":"IconButton_edgestart__2EqQJ"};